import { Marker } from '@vis.gl/react-maplibre';
import { Fragment } from 'react';

import { RouteLocationMarkerImage } from '@/components/map/RouteLocationMarkerImage';
import { Geocoder } from '@/modules/Geocoder';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { RouteLocationType } from '@/types/RouteLocationType';

export function RouteLocationMarkers() {
  const routeLocations = useRoutesStore((state) => state.routeLocations);
  const { updateRouteLocations } = useRoutesStore((state) => state.actions);

  return (
    <Fragment>
      {Object.values(RouteLocationType).map((routeLocationType) => {
        const routeLocation = routeLocations[routeLocationType];

        return routeLocation ? (
          <Marker
            key={routeLocationType}
            draggable
            anchor="bottom"
            latitude={routeLocation.geometry.coordinates[1]}
            longitude={routeLocation.geometry.coordinates[0]}
            onDragEnd={async (event) => {
              updateRouteLocations({
                routeLocationType,
                location: await Geocoder.reverse({
                  type: 'Point',
                  coordinates: [event.lngLat.lng, event.lngLat.lat],
                }),
              });
            }}
          >
            <RouteLocationMarkerImage markerType={routeLocationType} />
          </Marker>
        ) : null;
      })}
    </Fragment>
  );
}
